import { render } from "./AddHandlerRequest.vue?vue&type=template&id=66afcc17"
import script from "./AddHandlerRequest.vue?vue&type=script&lang=js"
export * from "./AddHandlerRequest.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__